import React from 'react';
import PublicLayout from '../components/PublicLayout';
import PrivacyGrid from '../components/PrivacyGrid';
const h=React.createElement;
export default function PrivacyPolicy(props) {
  return h(PublicLayout,{page:'privacy',isLoggedIn:props.isLoggedIn},
    h(PrivacyGrid,{isLoggedIn:props.isLoggedIn}));
}

